import React from 'react';
import ReactDOM from 'react-dom';
import { CssBaseline } from '@material-ui/core';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import store from './store/store';
//import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <React.Fragment>
    <Provider store={store}>
      <CssBaseline />
      <App />
    </Provider>
  </React.Fragment>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
